import { useTranslation } from 'react-i18next';
import { snackbarService } from '../snackbar/service/snackbar.service';
import { IImagePickerProps, ImageMimeType } from './imagePicker.component';

export const useValidation = (args: IValidationArgs) => {
  const { allowedImageMimeTypes, maxImgWidth, maxImgHeight, onError, setLoading } = args;
  const { t } = useTranslation();

  const checkImageType = (file: File) => {
    if (!allowedImageMimeTypes.includes(file.type as ImageMimeType)) {
      onError && onError(2);
      setLoading(false);
      return false;
    }
    return true;
  };

  const checkImageSize = (file: File) => {
    const maxFileSize = 1024 * 1024; // 1024 KB
    if (file.size > maxFileSize) {
      snackbarService.pub.show({
        content: t('common.the_image_size_must_be_less_than_x_kb', { size: maxFileSize / 1024 }),
        type: 'error',
      });
      setLoading(false);
      return false;
    }
    return true;
  };

  const checkImageWidth = (img: HTMLImageElement) => {
    if (maxImgWidth && img.width > maxImgWidth) {
      snackbarService.pub.show({
        content: t('common.image_width_must_be_less_than_x_px', { size: maxImgWidth }),
        type: 'error',
      });
      setLoading(false);
      return false;
    }
    return true;
  };

  const checkImageHeight = (img: HTMLImageElement) => {
    if (maxImgHeight && img.height > maxImgHeight) {
      snackbarService.pub.show({
        content: t('common.image_height_must_be_less_than_x_px', { size: maxImgHeight }),
        type: 'error',
      });
      setLoading(false);
      return false;
    }
    return true;
  };

  return {
    checkImageType,
    checkImageSize,
    checkImageWidth,
    checkImageHeight,
  };
};

interface IValidationArgs {
  allowedImageMimeTypes: ImageMimeType[];
  maxImgWidth?: number;
  maxImgHeight?: number;
  onError: IImagePickerProps['onError'];
  setLoading: (loading: boolean) => void;
}
